export const UPDATE_WHAT_TO_BRING = 'UPDATE_WHAT_TO_BRING';
export const UPDATE_ITEM_NAME = 'UPDATE_ITEM_NAME';
export const UPDATE_ITEM_QTY = 'UPDATE_ITEM_QTY';
export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const TOGGLE_EDIT = 'TOGGLE_EDIT';
export const TOGGLE_ALLOW = 'TOGGLE_ALLOW';
export const DELETE_WHAT_TO_BRING = 'DELETE_WHAT_TO_BRING';
export const UPDATE_OTHER_NAME = 'UDPATE_OTHER_NAME';
export const UPDATE_OTHER_QTY = 'UPDATE_OTHER_QTY';
export const CANCEL_OTHER = 'CANCEL_OTHER';


// WEBPACK FOOTER //
// ./assets/es6/view_invitation/what-to-bring/constants.es6